import { Component, computed, inject, OnDestroy } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { getRollupSelectedData, getRollupViewType } from '@app/store/rollups/rollups.selectors';
import {
  IRollupLineItemTable,
  IRollupTagTable,
  ROLLUP_VIEW_TYPES,
} from '@app/store/rollups/rollups.interface';
import { FormattedMoneyComponent } from '@app/framework/formated-money/formatted-money.component';

@Component({
  selector: 'app-rollups-manager-sidebar',
  imports: [FormattedMoneyComponent, NgScrollbar],
  templateUrl: './rollups-manager-sidebar.component.html',
  styleUrl: './rollups-manager-sidebar.component.scss',
})
export class RollupsManagerSidebarComponent implements OnDestroy {
  store = inject(Store);

  viewType = toSignal(this.store.select(getRollupViewType));
  selectedRollupData = toSignal(this.store.select(getRollupSelectedData));

  protected readonly ROLLUP_VIEW_TYPES = ROLLUP_VIEW_TYPES;
  private isDestroyed$ = new Subject<void>();

  bliData = computed(() => {
    return this.selectedRollupData() as IRollupLineItemTable;
  });

  tagsData = computed(() => {
    return this.selectedRollupData() as IRollupTagTable;
  });

  ngOnDestroy() {
    this.isDestroyed$.next();
    this.isDestroyed$.complete();
  }
}
